import { create } from 'zustand'
import { apiClient } from '../api/client'
import { API_ENDPOINTS } from '../api/endpoints'
import { parseCompanyModuleFlag } from '../utils/moduleHelpers'

interface ModuleState {
  enableDentalClinicModule: boolean
  enableISPModule: boolean
  enableProductionModule: boolean
  enableRestaurantModule: boolean
  enableCarRentalModule: boolean
  enableFixedAssetsModule: boolean
  enableFuelStationModule: boolean
  inventoryMethod: string | null
  modulesLoaded: boolean
  setModules: (modules: Partial<ModuleState>) => void
  loadCompanyModules: (companyId: string) => Promise<void>
}

export const useModuleStore = create<ModuleState>((set) => ({
  enableDentalClinicModule: true,
  enableISPModule: true,
  enableProductionModule: true,
  enableRestaurantModule: true,
  enableCarRentalModule: true,
  enableFixedAssetsModule: false,
  enableFuelStationModule: false,
  inventoryMethod: null,
  modulesLoaded: false,
  setModules: (modules) => set({ ...modules, modulesLoaded: true }),
  loadCompanyModules: async (companyId: string) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.companies.get(companyId))
      const data = response.data
      set({
        enableDentalClinicModule: parseCompanyModuleFlag(data, 'enableDentalClinicModule', 'EnableDentalClinicModule', true),
        enableISPModule: parseCompanyModuleFlag(data, 'enableISPModule', 'EnableISPModule', true),
        enableProductionModule: parseCompanyModuleFlag(data, 'enableProductionModule', 'EnableProductionModule', true),
        enableRestaurantModule: parseCompanyModuleFlag(data, 'enableRestaurantModule', 'EnableRestaurantModule', true),
        enableCarRentalModule: parseCompanyModuleFlag(data, 'enableCarRentalModule', 'EnableCarRentalModule', true),
        enableFixedAssetsModule: parseCompanyModuleFlag(data, 'enableFixedAssetsModule', 'EnableFixedAssetsModule', false),
        enableFuelStationModule: parseCompanyModuleFlag(data, 'enableFuelStationModule', 'EnableFuelStationModule', false),
        inventoryMethod: data.inventoryMethod ?? data.InventoryMethod ?? null,
        modulesLoaded: true,
      })
    } catch (error) {
      console.error('Error loading company modules:', error)
      set({ modulesLoaded: true })
    }
  }
}))
